import React from 'react'
import PropTypes from 'prop-types'
import {
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit'

const LegalNameChangeModal = ({ open, onConfirm, onCancel }) => (
  <MDBModal open={open} onClose={onCancel} tabIndex='-1'>
    <MDBModalDialog centered>
      <MDBModalContent>
        <MDBModalHeader>
          <MDBModalTitle>
            <MDBIcon icon='exclamation-triangle' className='mr-2 text-warning' />
            Legal Name Change
          </MDBModalTitle>
          <MDBBtn type='button' className='btn-close' color='none' onClick={onCancel}></MDBBtn>
        </MDBModalHeader>
        <MDBModalBody>
          <p>You are attempting to change the spelling of your legal name on file.</p>
          <p>If you have a minor typo in your name, please feel free to go ahead and change that now.</p>
          <p>
            If you need to change the name on your account, please reach out to our broker support team so we can make
            all necessary changes on the backend of your account.
          </p>
          <p className='mb-0'>
            If you just want the rest of the organization or our software to know you by a certain name, use the{' '}
            <strong>Nickname</strong> field instead. The legal name field is not read-only, but the legal name is not
            supposed to change. The Nickname field controls how your name appears to others throughout the back-office
            system. For example, if your legal name is ‘William’ but you go by ‘Bill,’ leave ‘William’ in the legal
            first name and enter ‘Bill’ in the Nickname field.
          </p>
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn type='button' color='flat' onClick={onCancel}>
            Cancel
          </MDBBtn>
          <MDBBtn type='button' color='danger' onClick={onConfirm}>
            I understand, continue
          </MDBBtn>
        </MDBModalFooter>
      </MDBModalContent>
    </MDBModalDialog>
  </MDBModal>
)

LegalNameChangeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default LegalNameChangeModal
